import { FloatingLabel, Form, Button, Alert } from "react-bootstrap";
import "./Auth.css";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import config from "../../config";
import csLogo from "../../img/CSHub-logo.png";
import toolLogo from "../../img/streamlined-tool-log.png"; // Adjust the path to your second logo

const SignIn = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showErrors, setShowErrors] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const handleEmailChange = (e) => setEmail(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowErrors(true);

        const trimmedEmail = email.trim();
        const trimmedPassword = password.trim();

        if (!trimmedEmail || !trimmedPassword) {
            setErrorMessage("Please fill all the fields");
            return;
        }

        try {
            const response = await axios.post(`${config.apiUrl}/api/auth/login`, {
                email: trimmedEmail,
                password: trimmedPassword
            });

            // If login is successful
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem("user_id", response.data.user_id);

            navigate('/dashboard');
        } catch (error) {
            // Check if error response exists and contains a specific error message
            if (error.response && error.response.data && error.response.data.error) {
                setErrorMessage(`Login failed: ${error.response.data.error}`);
            } else {
                setErrorMessage("Login failed: An unexpected error occurred.");
            }
        }
    };


    return (
        <div className="auth__box">
            <div className="signin__box--left">
                <img src={csLogo} alt="CSHub Logo" id="signin__left--image" />
                {/*<img src="../../img/CSHub-logo.png" alt="CSHublogo" class="signin__left--image"> {/*<!-- Add image here -->*/}
                <h1 className="signin__left--title">Sign In</h1>
                <p className="signin__left--text">Please sign in below if you already have an account.</p>
                <Form className="signin__left--form" noValidate onSubmit={handleSubmit}>
                    <FloatingLabel controlId="floatingInput" label="Email" className="mb-3">
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            className="auth__input"
                            placeholder="name@example.com"
                            required
                            isInvalid={showErrors && !email}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                        </Form.Control.Feedback>
                    </FloatingLabel>
                    <FloatingLabel controlId="floatingPassword" label="Password">
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            className="auth__input"
                            placeholder="Password"
                            required
                            isInvalid={showErrors && !password}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a password.
                        </Form.Control.Feedback>
                    </FloatingLabel>
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                    <Button className="signin__box--left--button" type="submit">Sign In</Button>
                    <p className="signin__left--bottomtext">
                        2026 &copy; MIT.{" "}
                        <a href="https://accessibility.mit.edu/" target="_blank" rel="noopener noreferrer">
                            Learn about MIT's commitment to accessibility.
                        </a>
                    </p>
                </Form>
            </div>
            <div className="signin__box--right">
                <img src={toolLogo} alt="ToolLogo" id="signin__left--image" />
                <h1 className="signin__right--title">MIT CSHub Streamlined Pavement LCA & LCCA Tool</h1>
                <p className="signin__right--text">Please click the button below to sign up if you would like to create a new account.(The tool has been recently updated. You may need to register again if you haven’t logged in for a while.)</p>
                <Button className="signin__box--right--button" href="/signup">Sign Up</Button>
                <p className="signin__right--bottomtext">
                    MIT CSHub | cshub@mit.edu
                </p>
            </div>
        </div>
    );
};

export default SignIn;
